module.exports = __webpack_public_path__ + "img/lpq.e411994e.jpg";